<div #ShowReadOnlyLocation *ngIf="checkoutService.showReadOnlyLocation()">
  <div class="option-wrapper">
    <div class="section-title p-3 pl-4 mb-0 font-size-primary theme-light">
      {{
      (checkoutService.selectedStore?.settings?.ORDER_FULFILMENT_METHOD === 'PICKUP_AND_RETURN')
      ? ('​public.checkout.yourOrderServed' | translate)
      : ('public.checkout.title.serve.known.location' | translate) }}

    </div>
    <div class="variant-wrapper my-3">
      <app-customer-login></app-customer-login>
      <div class="px-3 pl-4 mt-3 mb-2 font-size-heading align-items-center">
        <span
          *ngIf="getStoreLocationType() === LocationType.ROOM || !getStoreLocationType() && selectedStore && selectedStore.settings && selectedStore.settings.DEFUALT_LOCATION_TYPE === LocationType.ROOM"
          class="theme-color-header">
          {{'public.checkout.yourRoom' | translate}}
        </span>
        <span
          *ngIf="getStoreLocationType() === LocationType.POLE || !getStoreLocationType() && selectedStore && selectedStore.settings && selectedStore.settings.DEFUALT_LOCATION_TYPE === LocationType.POLE"
          class="theme-color-header">
          {{'public.checkout.yourPole' | translate}}
        </span>
        <span
          *ngIf="getStoreLocationType() === LocationType.SEAT || !getStoreLocationType() && selectedStore && selectedStore.settings && selectedStore.settings.DEFUALT_LOCATION_TYPE === LocationType.SEAT"
          class="theme-color-header">
          {{'public.checkout.yourSeat' | translate}}
        </span>
        <span
          *ngIf="getStoreLocationType() === LocationType.SUNBED || !getStoreLocationType() && selectedStore && selectedStore.settings && selectedStore.settings.DEFUALT_LOCATION_TYPE === LocationType.SUNBED"
          class="theme-color-header">
          {{'public.checkout.yourSunbed' | translate}}
        </span>
        <span
          *ngIf="getStoreLocationType() === LocationType.UMBRELLA || !getStoreLocationType() && selectedStore && selectedStore.settings && selectedStore.settings.DEFUALT_LOCATION_TYPE === LocationType.UMBRELLA"
          class="theme-color-header">
          {{'public.checkout.yourUmbrella' | translate}}
        </span>
        <span
          *ngIf="getStoreLocationType() === LocationType.SOFA || !getStoreLocationType() && selectedStore && selectedStore.settings && selectedStore.settings.DEFUALT_LOCATION_TYPE === LocationType.SOFA"
          class="theme-color-header">
          {{'public.checkout.yourSofa' | translate}}
        </span>
        <span
          *ngIf="getStoreLocationType() === LocationType.AIRBNB || !getStoreLocationType() && selectedStore && selectedStore.settings && selectedStore.settings.DEFUALT_LOCATION_TYPE === LocationType.AIRBNB"
          class="theme-color-header">
          {{'public.checkout.yourAirbnb' | translate}}
        </span>
        <span
          *ngIf="getStoreLocationType() === LocationType.LOCATION || !getStoreLocationType() && selectedStore && selectedStore.settings && selectedStore.settings.DEFUALT_LOCATION_TYPE === LocationType.LOCATION"
          class="theme-color-header">
          {{'public.checkout.yourLocation' | translate}}
        </span>
        <span
          *ngIf="getStoreLocationType() === LocationType.TABLE || !getStoreLocationType() && (!selectedStore || !selectedStore.settings || !selectedStore.settings.DEFUALT_LOCATION_TYPE || selectedStore.settings.DEFUALT_LOCATION_TYPE === LocationType.TABLE)"
          class="theme-color-header">
          {{'public.checkout.yourTable' | translate}}
        </span>
        <i class="fas fa-map-marker-alt mr-1 theme-color-icon"></i> <span
          class="theme-color-header">{{getLocationLabel()}}</span>
        <a href="javascript:void(0);" class="font-size-23" *ngIf="location.isOrderCapture()" (click)="clearLocation()">
          <i class="fas fa-times-circle ml-5 font-size-23"></i>
        </a>
      </div>
      <div *ngIf="getLocationDescription()" class="px-4 font-size-primary">
        {{getLocationDescription()}}
      </div>
    </div>
  </div>
</div>
<div #ShowEditableLocation *ngIf="checkoutService.showEditableLocation()">
  <div class="option-wrapper">
    <div class="variant-wrapper my-2 my-md-0">
      <div class="section-title p-3 mb-3 font-size-primary pl-4 theme-light" *ngIf="!checkoutService.showChoices()">
        {{
        (checkoutService.selectedStore?.settings?.ORDER_FULFILMENT_METHOD === 'PICKUP_AND_RETURN')
        ? ('​public.checkout.yourOrderServed' | translate)
        : ('public.checkout.title.serve.unknown.location' | translate) }}
      </div>
      <app-customer-login></app-customer-login>
      <div class="mx-3">
        <form [formGroup]="checkoutOptionsForm">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group mx-2 mb-4">
                <app-input-text inputId="table" autocomplete="table" maxLength="10" [label]="getLabel() | translate"
                  [required]="true" [control]="getControl('table')"
                  [isInvalid]="(checkoutService.showErrors(getControl('table')) || getControl('table').errors?.invalidLocation || getControl('table').errors?.whitespace)"
                  [errorText]="(
                      getControl('table')?.errors?.required ? ('public.checkout.errors.fieldRequired' | translate) : 
                      (
                        getControl('table')?.errors?.invalidLocation || 
                        getControl('table')?.errors?.whitespace
                      ) ? ('public.payment.errors.valueNotValid' | translate) : ''
                    )" (keyupEvent)="checkValidateLocation(); validateLocation('table')"
                  (focusoutEvent)="validateLocation('table')" />
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<div class="mx-3 option-wrapper" *ngIf="requirePin()">
  <form [formGroup]="checkoutOptionsForm">
    <div class="row">
      <div class="col-md-12">
        <div class="form-group mx-2 mb-4">
          <app-input-text inputId="pinnumber" autocomplete="pinnumber" maxLength="4"
            [label]="'public.checkout.enterPin' | translate" [required]="true" [control]="getControl('pinnumber')"
            [isInvalid]="showPinErrors()" [errorText]="(
                (
                  ((!isPinValid && getControl('pinnumber').errors?.required) || getControl('pinnumber').value?.length === 0) && 
                  checkoutService.invalidSubmit()
                ) ? ('public.checkout.errors.fieldRequired' | translate) : 
                (
                  getControl('pinnumber').errors?.invalidPin && 
                  getControl('pinnumber').value?.length > 0
                ) ? ('public.checkout.errors.invalidPin' | translate) : ''
              )" (keyupEvent)="validatePin()" />
        </div>
      </div>
    </div>
  </form>
</div>